<template>
  <b-row
    v-if="($route.meta.breadcrumb || $route.meta.pageTitle) && !$route.meta.hidePageTitle"
    class="content-header"
  >
    <!-- Content Left -->
    <b-col class="content-header-left mb-2" cols="12">
      <b-row class="breadcrumbs-top">
        <b-col cols="12">
          <div class="d-flex" style="min-height: 30px">
            <Breadcrumbs />
          </div>
          <div class="d-flex justify-content-between align-items-center">
            <h2 class="content-header-title float-left pr-1 mb-0 border-0">
              {{ t($route.meta.pageTitle) }}
            </h2>
            <portal-target name="header-actions" slim />
          </div>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue';
import Ripple from 'vue-ripple-directive';
import { useUtils as useI18nUtils } from '@core/libs/i18n';

export default {
  directives: {
    Ripple
  },
  components: {
    BRow,
    BCol
  },
  setup() {
    const { t } = useI18nUtils();

    return {
      t
    };
  }
};
</script>
